const CPLUS2_CITATIONS_MAX_FILE_SIZE_MB =
  process.env.CPLUS2_CITATIONS_MAX_FILE_SIZE_MB || '10';

export const ENV = {
  CPLUS2_CITATIONS_MAX_FILE_SIZE_MB: +CPLUS2_CITATIONS_MAX_FILE_SIZE_MB
};
